/* --------------------------------------------------------------------------------------
snmp.service.js
   Copyright © 2020 Xerox Corporation. All Rights Reserved.
     
   Copyright protection claimed includes all forms and matters of copyrightable material
   and information now allowed by statutory or judicial law or hereinafter granted,
   including without limitation, material generated from the software programs which
   are displayed on the screen such as icons, screen display looks, etc.
--------------------------------------------------------------------------------------*/

export class snmpService {
  /* @ngInject */
  constructor(sessionDataService) {
    this.sessionDataService = sessionDataService;
  }
  get(oid) {
    const result = xrxWsSnmpGet(
      this.sessionDataService.deviceUrl,
      "public",
      oid,
      null,
      null,
      5,
      false
    );
    const parsedResult = xrxWsSnmpParseGet(result);
    return parsedResult.returnValue;
  }
  getAsync(oid) {
    return this.wsSnmpGet(this.sessionDataService.deviceUrl, "public", oid, 5);
  }
  wsSnmpGet(url, communityString, oid, timeout) {
    return new Promise((resolve, reject) => {
      xrxWsSnmpGet(
        url,
        communityString,
        oid,
        (result) => resolve(xrxWsSnmpParseGet(result)),
        (error) => reject(error),
        timeout,
        true
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/snmp.service.js